import { createFileRoute } from "@tanstack/react-router";
import { WaitingBackend } from "@/components/waiting-backend";

export const Route = createFileRoute("/groups")({
  component: () => (
    <div className="p-6 space-y-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight">Grupos</h1>
        <p className="text-sm text-muted-foreground">Organize veículos em grupos operacionais.</p>
      </div>
      <WaitingBackend />
    </div>
  ),
  head: () => ({ meta: [{ title: "Grupos — Wp Rastreamento" }] }),
});
